import * as React from 'react';
import Translator from './Translator';
import { LanguageEntries } from '../shared/language/LanguageEntries';

interface Props {
  entry: keyof LanguageEntries;
}

const Translate: React.SFC<Props> = ({ entry }) => <Translator>{translate => translate(entry)}</Translator>;

export default Translate;



// WEBPACK FOOTER //
// ./src/components/Translate.tsx